export enum PermissionButtonType {
  CHECK_FUNC = 1,
  CHECK_ALL_ROW = 2
}

export enum PageRouteEnum {
  DASHBOARD = 1,
  LIST_USER = 2,
  REPORTS = 3,
  SALE_REPORT = 4,
  DIGITAL_REPORT = 5,
  REFUND_RATE = 6,
  OMICALL = 7,
  DIGITAL_MANAGEMENT = 8,
  VERIFY_ACCOUNT_MXH = 9,
  MARKETING_FEE_ACTUAL = 10,
  COST_ADS = 11,
  SOCIAL_MANAGEMENT = 12,
  LIST_SOCIAL = 13,
  SYS_MANAGEMENT = 14,
  TEAM = 15,
  EXPECTED_REVENUE = 16,
  CLOSING_SALES = 17,
  MARKETING_FEE_BY_MONTH = 18,
  PAGE_PERMISSION = 19,
  ROLE_PERMISSION = 20,
  UPLOAD_SOCIAL = 21,
  MARKETING_USERNAME = 22,
  BANK_CARD = 23,
  SYSTEM=24,
  LIST_PRODUCT = 25

}

export enum FunctionEnum {
  CREATE = 1,
  ADD = 2,
  EDIT = 3,
  DELETE = 4,
  SUBMIT = 5,
  READ = 6,
  FULL = 7,
  SEARCH = 8,
  PHAN_QUYEN = 9,
  APPROVE = 10
}
